import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";

import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { LIBRARY_EDITOR } from "../../../../common/constant";
import Visibility from "../../../../component/common/VisibleContainer";
import SurveyUtils from "../../../../utils/SurveyUtils";
import QuestionLibraryOverviewRows from "./QuestionLibraryOverviewRows";

/**
 * Component which represents table for questions from library
 */
class QuestionLibraryOverviewTable extends Component {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
    this.onSortColumn = this.onSortColumn.bind(this);
  }

  render() {
    const { questionLibrary, sortTableOrder, sortTableBy, locale } = this.props;
    return (
      <Table responsive className="question-library-table">
        <thead>
          <tr>
            <th className={SurveyUtils.addClassForTableHeader("name", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("name")}>
                <FormattedMessage id="question.library.set.question.name" />
                {SurveyUtils.sortIcon("name", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <th className={SurveyUtils.addClassForTableHeader("questionId", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("questionId")}>
                <FormattedMessage id="question.library.set.question.id" />
                {SurveyUtils.sortIcon("questionId", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <th className={SurveyUtils.addClassForTableHeader("question", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("question", "type")}>
                <FormattedMessage id="survey.editor.add.question.question.type" />
                {SurveyUtils.sortIcon("question", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <th className={SurveyUtils.addClassForTableHeader("language", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("language", "name")}>
                <FormattedMessage id="app.common.Language" />
                {SurveyUtils.sortIcon("language", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <th className={SurveyUtils.addClassForTableHeader("actionField", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("actionField", "name", locale)}>
                <FormattedMessage id="indicator.management.action.field" />
                {SurveyUtils.sortIcon("actionField", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <th className={SurveyUtils.addClassForTableHeader("result", sortTableBy, sortTableOrder)}>
              <Button variant="link" onClick={() => this.onSortColumn("result", "name", locale)}>
                <FormattedMessage id="indicator.management.result" />
                {SurveyUtils.sortIcon("result", sortTableBy, sortTableOrder)}
              </Button>
            </th>
            <Visibility roles={[LIBRARY_EDITOR]} as="th" className="actions">
              <FormattedMessage id="app.common.title.actions" />
            </Visibility>
          </tr>
        </thead>
        <tbody>{questionLibrary.map(this.renderRow)}</tbody>
      </Table>
    );
  }

  /**
   * A row renderer
   */
  renderRow(question) {
    const { showSettingsModalQuestionToLibrary, sortTableBy, locale } =
      this.props;
    return (
      <QuestionLibraryOverviewRows
        question={question}
        key={question.id}
        sortTableBy={sortTableBy}
        showSettingsModalQuestionToLibrary={showSettingsModalQuestionToLibrary}
        locale={locale}
      />
    );
  }

  onSortColumn(columnType, subtype, language) {
    const { sortTableOrder, sortTableBy, sortColumn, colSubtype } = this.props;
    //triggers sorting.
    if (sortTableBy === columnType && colSubtype === subtype) {
      sortColumn(columnType, subtype, !sortTableOrder, language);
    } else {
      sortColumn(columnType, subtype, true, language);
    }
  }
}

QuestionLibraryOverviewTable.propTypes = {
  questionLibrary: PropTypes.array,
  showSettingsModalQuestionToLibrary: PropTypes.func,
  removeQuestionFromLibrary: PropTypes.func,
  sortColumn: PropTypes.func,
  showDialog: PropTypes.func,
  sortTableOrder: PropTypes.bool,
  colSubtype: PropTypes.string,
  sortTableBy: PropTypes.string,
  locale: PropTypes.string.isRequired
};

export default injectIntl(QuestionLibraryOverviewTable);
